import apiService from "./api";

const employeeService = {
  addMultipleUsers(companyId, payload) {
    return apiService.post(
      `/companies/${companyId}/add-multiple-users`,
      payload
    );
  },
  getParentCompanies(companyId) {
    return apiService.get(`/companies/${companyId}/parent-companies`);
  },
  setTimeLimit(item) {
    return apiService.post("/user/change-user-time-limit", item);
  },
  setCanReport(data) {
    return apiService.post("/user/can-see-company-reports", data);
  },
  getCompanies() {
    return apiService.get("/companies");
  },
  getUsers(route) {
    return apiService.get(route);
  },
  deleteUser(userId) {
    return apiService.delete(`/user/${userId}`);
  },
  getCompanyUsers(companyId) {
    return apiService.get(`/companies/${companyId}/users`);
  },
  getCompanyUsersDelivery(companyId) {
    return apiService.get(`/companies/${companyId}/users-delivery`);
  },
  getRestaurantUsers(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users`);
  },
  getRestaurantUsersDelivery(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users-delivery`);
  },
  // Update user (employee)
  updateUser(userId, userData) {
    return apiService.patch(`/user/${userId}`, userData);
  },
  // Create user based on route (company or restaurant)
  createCompanyUser(companyId, userData, isDelivery = false) {
    const endpoint = isDelivery ? "users-delivery" : "users";
    return apiService.post(`/companies/${companyId}/${endpoint}`, userData);
  },
  createRestaurantUser(restaurantId, userData, isDelivery = false) {
    const endpoint = isDelivery ? "users-delivery" : "users";
    return apiService.post(`/restaurants/${restaurantId}/${endpoint}`, userData);
  },
  // Upload user photo
  uploadUserPhoto(formData) {
    return apiService.post("/user/photo", formData);
  },
  // Change user company
  changeUserCompany(userData) {
    return apiService.post("/companies/change-user-company", userData);
  },
};

export default employeeService;
